module.exports = __webpack_public_path__ + "static/media/globalconnect-hires.eca3e244.png";